import { useState, useEffect } from 'react';

const useTextFile = (downloadUrl) => {
    const [fileText, setFileText] = useState({});
    useEffect(() => {
        const fetchFile = async () => {
            const file = await fetch(downloadUrl);
            const body = await file.text();
            setFileText(body);
        };
        fetchFile();
    }, [downloadUrl]);
    return fileText;
};

export default useTextFile;
